"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetryPlugin = void 0;
const constants_1 = require("./constants");
const entryRetry_1 = require("./entryRetry");
const RetryPlugin = (options) => {
    const { retryTimes = constants_1.defaultRetries, retryDelay = constants_1.defaultRetryDelay, hosts = [], getLastSuccessHost, onRetry, onError, onSuccess, } = options || {};
    return {
        name: '@vk-tech-solar/module-federation-retry-plugin',
        //@ts-ignore
        loadEntry({ remoteInfo, }) {
            if (hosts && hosts.length && getLastSuccessHost) {
                const lastSuccessHost = getLastSuccessHost();
                if (lastSuccessHost && hosts.includes(lastSuccessHost)) {
                    const parsed = URL.parse(remoteInfo.entry);
                    let url;
                    if (parsed) {
                        url = parsed;
                    }
                    else {
                        url = new URL(`${lastSuccessHost}${remoteInfo.entry}`);
                    }
                    if (!lastSuccessHost.endsWith(url.hostname)) {
                        url.hostname = new URL(lastSuccessHost).hostname;
                        if (!remoteInfo.originalUrl ||
                            remoteInfo.originalUrl !== url.toString()) {
                            remoteInfo.entry = url.toString();
                        }
                    }
                }
            }
        },
        loadEntryError({ getRemoteEntry, origin, remoteInfo, remoteEntryExports, globalLoading, }) {
            const retryFn = getRemoteEntry;
            const beforeExecuteRetry = (name) => {
                const key = Object.keys(globalLoading).find((key) => key.includes(`${name}:`));
                if (key) {
                    delete globalLoading[key];
                }
            };
            const getRemoteEntryRetry = (0, entryRetry_1.CommonEntryRetry)({
                options: {
                    hosts,
                    retryTimes,
                    retryDelay,
                    onRetry,
                    onError,
                    onSuccess,
                },
                retryFn,
                beforeExecuteRetry,
            });
            return getRemoteEntryRetry({
                origin,
                remoteInfo,
                remoteEntryExports,
            });
        },
    };
};
exports.RetryPlugin = RetryPlugin;
